import React, { Component } from 'react'

export default class NotFound extends Component {
  render() {
    return (
      <div className="not-found">
        <h2>Oops!</h2>
        <br />
        <h2>We weren't able to find what you were looking for.</h2>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotFound.js